/* eslint-disable */
import React, { useState, useEffect, useContext, useRef, useCallback, } from "react";
import { withRouter, RouteComponentProps } from 'react-router';
import { Input, Dropdown, Menu, Tooltip, Row, Table, Col, Slider, Button, List, Typography, Modal, Select, Checkbox, Form, Spin, Space, } from "antd";
import { SearchOutlined, CheckOutlined, PlusOutlined, MinusOutlined, CloseOutlined, ArrowLeftOutlined, DownOutlined, LoadingOutlined } from "@ant-design/icons";
import "./index.scss";
import { toSentenceCase } from "../../utils/utils";
import { connect } from "react-redux";
import * as createActions from "../../actions/createTrial.js";
import { formatValue, formatHistoryValue, formatTime, formatHistoryTime } from '../../utils/auth';
import { compareString, compareMiddle, filterOptions } from '../../utils/common-function';
import IEDetailsModal from '../IEDetailsModal';
import { getCriteriaLibByNctId } from "src/utils/ajax-proxy";
const { Text } = Typography;

const EditableContext = React.createContext(null);
interface Record {
  Text: string;
  historical_timeframe: string;
  user_timeframe: string;
  Frequency: number | null;
  details: string | null;
  negation: boolean;
  criteria_category: string;
  historical_roa: string;
  user_roa: string;
  historical_acuity: string;
  user_acuity: string;
  historical_treatment: string;
  historical_anatomical_site: string;
  user_treatment: string;
  user_anatomical_site: string;
  historical_lower: number;
  user_lower: number;
  historical_units: string;
  user_units: string;
  historical_upper: number;
  user_upper: number;
  user_value: string;
}


interface Props extends RouteComponentProps {
  location: {
    pathname: string;
    search: string;
    hash: string;
    state: {
      IEType: string;
      originDemographics: Record[];
      originIntervention: Record[];
      originMedCondition: Record[];
      originLabTest: Record[];
      demographicsSelected: Record[];
      interventionSelected: Record[];
      medConditionSelected: Record[];
      labTestSelected: Record[];
      similarHistoricalTrials: any;
      trial_id: string;
      scenarioId: string;
      scenarioType: string;
      readOnly: boolean;
    };
  };
  newIE: any;
  updateIEActivities: (val: any) => void;
}

const EditableDetailRow:React.FC<any> = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableDetailCell: React.FC<any> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({
        ...record,
        ...values,
      });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };
  let childNode = children;
  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
        }}
        name={dataIndex}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} style={{ width: "300px", fontSize: 14}} />
      </Form.Item>
    ) : (
      <div
        className="detail-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
        onFocus={toggleEdit}
      >
        {children}
      </div>
    );
  }
  return <td {...restProps}>{childNode}</td>;
};

const AddActivityIE: React.FC<Props> = (props) => {

  const initialActivity: Record = {
    "Text": '',
    "historical_timeframe": '',
    "user_timeframe": '',
    "Frequency":null,
    "details":null,
    "negation": false,
    'criteria_category': '',
    'historical_roa': '',
    'user_roa': '',
    'historical_acuity': '',
    'user_acuity': '',
    'historical_treatment': '',
    'historical_anatomical_site': '',
    'user_treatment': '',
    'user_anatomical_site': '',
    'historical_lower': 0,
    'user_lower': 0,
    'historical_units': '',
    'user_units': '',
    'historical_upper': 0,
    'user_upper': 0,
    'user_value': ''
  }

  const {
    IEType,
    originDemographics,
    originIntervention,
    originMedCondition,
    originLabTest,
    demographicsSelected,
    interventionSelected,
    medConditionSelected,
    labTestSelected,
    similarHistoricalTrials,
    trial_id,
    scenarioId,
    scenarioType,
    readOnly
  } = props.location.state;

  let [demographicsElementsSelect, setDemographicsElementsSelect] = useState<Record[]>([])
  let [interventionElementsSelect , setInterventionElementsSelect ] = useState<Record[]>([])
  let [medConditionElementsSelect, setMedConditionElementsSelect] = useState<Record[]>([])
  let [labTestElementsSelect, setLabTestElementsSelect] = useState<Record[]>([])

  const [visibleValue, setVisibleValue] = useState(false);
  const [visibleFilterValue, setVisibleFilterValue] = useState(false);
  const [searchTxt,setSearchTxt] = useState("");


  const [filteredActivities, setFilteredActivities] = useState<Record[]>([]);
  const [selectedActivities, setSelectedActivities] = useState<Record[]>([]);
  const [panelActivities, setPanelActivities] = useState<Record[]>([]);

  const categoryList = [ "Demographics", "Medical Condition", "Intervention", "Lab / Test" ]
  const [categories, setCategories] = useState<string[]>(categoryList);
  const [filterbyCategories, setFilterByCategories] = useState<string[]>(categoryList)

  const frequencyFilter = [5, 100]
  const [minValue, setMinValue] = useState(frequencyFilter[0])  //Slider bar minimon value
  const [maxValue, setMaxValue] = useState(frequencyFilter[1])  //Slider bar maximom value
  
  const [filterByMin, setFilterByMin] = useState(frequencyFilter[0])
  const [filterByMax, setFilterByMax] = useState(frequencyFilter[1])

  //Filtered libs for display and selection purpose

  const [demographics, setDemographics] = useState<Record[]>([])
  const [intervention, setIntervention] = useState<Record[]>([])
  const [medCondition, setMedCondition] = useState<Record[]>([])
  const [labTest, setLabTest] = useState<Record[]>([])

  // search bar data
  const [searchedCriteria, setSearchedCriteria] = useState<Record[]>([])

  const [tableListItems, setTableListItems] = useState<Record[]>([])
  const [current, setCurrent] = useState(1) 

  const [addActivityModal, setAddActivityModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState<Record>(initialActivity)
  const [modifierActivity, setModifierActivity] = useState<Record>(initialActivity)

  const [isResultLoading, setResultLoading] = useState<boolean>(false);

  const [detailData, setDetailData] = useState([
    {
      key: '1',
      name: 'Values',
      history: formatHistoryValue(selectedActivity)|| '',
      modifiers: formatValue(modifierActivity)==='-'?'': formatValue(modifierActivity),
    },
    {
      key: '2',
      name: 'Timeframe',
      history: formatHistoryTime(selectedActivity)|| '',
      modifiers: formatTime(modifierActivity)==='-'?'':formatTime(modifierActivity),
    },
    {
      key: '3',
      name: 'RoA',
      history: selectedActivity['historical_roa'] || '-',
      modifiers: modifierActivity['user_roa'] || '',
    },
    {
      key: '4',
      name: 'Acuity',
      history:selectedActivity['historical_acuity'] || '-',
      modifiers: modifierActivity['user_acuity'] || '',
    },
    {
      key: '5',
      name: 'Treatment modifier',
      history: selectedActivity['historical_treatment'] || '-',
      modifiers: modifierActivity['user_treatment'] || '',
    },
    {
      key: '6',
      name: 'Anatomical site',
      history: selectedActivity['historical_anatomical_site'] || '-',
      modifiers: modifierActivity['user_anatomical_site'] || '',
    },
  ]);

  useEffect(() => {
    setDetailData([
      {
        key: '1',
        name: 'Values',
        history: formatHistoryValue(selectedActivity)|| '',
        modifiers: formatValue(modifierActivity)==='-'?'':formatValue(modifierActivity),
      },
      {
        key: '2',
        name: 'Timeframe',
        history: formatHistoryTime(selectedActivity)|| '',
        modifiers: formatTime(modifierActivity)==='-'?'':formatTime(modifierActivity),
      },
      {
        key: '3',
        name: 'RoA',
        history: selectedActivity['historical_roa'] || '-',
        modifiers: modifierActivity['user_roa'] || '',
      },
      {
        key: '4',
        name: 'Acuity',
        history:selectedActivity['historical_acuity'] || '-',
        modifiers: modifierActivity['user_acuity'] || '',
      },
      {
        key: '5',
        name: 'Treatment modifier',
        history: selectedActivity['historical_treatment'] || '-',
        modifiers: modifierActivity['user_treatment'] || '',
      },
      {
        key: '6',
        name: 'Anatomical site',
        history: selectedActivity['historical_anatomical_site'] || '-',
        modifiers: modifierActivity['user_anatomical_site'] || '',
      },
    ])
  },[]);

  useEffect(() => {
    // console.log("----props.newIE",props.newIE);
    if(IEType==='Inclusion Criteria') {
      setDemographicsElementsSelect(props.newIE?.demographicsSelect?.length > 0? props.newIE?.demographicsSelect : demographicsSelected)
      setInterventionElementsSelect(props.newIE?.interventionElements?.length > 0? props.newIE?.interventionElements : interventionSelected)
      setMedConditionElementsSelect(props.newIE?.medConditionElements?.length > 0? props.newIE?.medConditionElements : medConditionSelected)
      setLabTestElementsSelect(props.newIE?.labTestElements?.length > 0? props.newIE?.labTestElements : labTestSelected)
    } else if(IEType==='Exclusion Criteria') {
      setDemographicsElementsSelect(props.newIE?.excluDemographicsElements?.length > 0? props.newIE?.excluDemographicsElements : demographicsSelected)
      setInterventionElementsSelect(props.newIE?.excluInterventionElements?.length > 0? props.newIE?.excluInterventionElements : interventionSelected)
      setMedConditionElementsSelect(props.newIE?.excluMedConditionElements?.length > 0? props.newIE?.excluMedConditionElements : medConditionSelected)
      setLabTestElementsSelect(props.newIE?.excluLabTestElements?.length > 0? props.newIE?.excluLabTestElements : labTestSelected)
    }
  }, [props.newIE, demographicsSelected, interventionSelected, medConditionSelected, labTestSelected])

  useEffect(() => {       
  setFilteredActivities( 
    [...demographics,
    ...intervention,
    ...medCondition,
    ...labTest])
  }, [demographics,
  intervention,
  medCondition,
  labTest])

  useEffect(() => {       
    setSelectedActivities( 
      [...demographicsSelected,
        ...interventionSelected,
        ...medConditionSelected,
        ...labTestSelected,])
        
    }, [demographicsSelected,
    interventionSelected,
    medConditionSelected,
    labTestSelected,])

  useEffect(() => {
    // filter the origin criteria with frequency 1% to 100%
    setDemographics(originDemographics.filter((d) => {
        return d.Frequency * 100 >= 1 && d.Frequency * 100 <= 100;
    }))
    setIntervention(originIntervention.filter((d) => {
        return d.Frequency * 100 >= 1 && d.Frequency * 100 <= 100;
    }))
    setMedCondition(originMedCondition.filter((d) => {
      return d.Frequency * 100 >= 1 && d.Frequency * 100 <= 100;
    }))
    setLabTest(originLabTest.filter((d) => {
        return d.Frequency * 100 >= 1 && d.Frequency * 100 <= 100;
    }))
  }, []);

  useEffect(() => {      
    setDemographicsElementsSelect( [...demographicsSelected])
  }, [ demographicsSelected ])

  useEffect(() => {      
    setInterventionElementsSelect([...interventionSelected ])
  }, [ interventionSelected ])

  useEffect(() => {
    setMedConditionElementsSelect([...medConditionSelected ])
  }, [ medConditionSelected ])

  useEffect(() => {
    setLabTestElementsSelect([...labTestSelected])
  }, [ labTestSelected ])

  const sortOptions = (options: Record[], attr: string) => {
    return options.sort((a, b) => {
    if (a[attr].toLowerCase() < b[attr].toLowerCase()) return -1;
    if (a[attr].toLowerCase() > b[attr].toLowerCase()) return 1;
    return 0;
  })
  }
  const customOrder = ['Demographics', 'Intervention', 'Medical Condition', 'Lab / Test'];
  const summaryDefaultList = async (search) => {   
      setResultLoading(true);  
      setSearchedCriteria([]);
     const resp = await getCriteriaLibByNctId(props.location.state.similarHistoricalTrials, props.location.state.trial_id, search);
     if (resp && Object.keys(resp).length !== 0) {
        const response = resp;
        let inclusionCriteria = []
        if(IEType==='Inclusion Criteria') {
          inclusionCriteria = response.Inclusion
        }else if(IEType==='Exclusion Criteria') {
          inclusionCriteria = response.Exclusion
        }

       if(inclusionCriteria) {
          let mergedArrayCustomOrder = customOrder.reduce((acc, key) => {
            return acc.concat(inclusionCriteria[key] || []);
          }, []);
          mergedArrayCustomOrder = mergedArrayCustomOrder.filter((i) =>
            i.Frequency * 100 >= minValueLimit &&
            i.Frequency * 100 <= maxValueLimit &&
            i.Text !== null)

          setSearchedCriteria(sortOptions(mergedArrayCustomOrder, 'Text'));
        }else {
          setSearchedCriteria([]);
        }
        setResultLoading(false);
      }else {
         setSearchedCriteria([]);
         setResultLoading(false);
      }
    };

  useEffect(() => {
    let flag = 0
    let tableListItemTmp = filteredActivities.filter((d)=>{
      return d.Frequency * 100 >= filterByMin && d.Frequency * 100 <= filterByMax && filterbyCategories.includes(d.criteria_category)
    }).map((item,index) =>{
      switch (item.criteria_category.charAt(0)) {
        case "D":
          flag = demographicsElementsSelect.findIndex((e) => {
              return e["Eligibility Criteria"] == item.Text && e["negation"] == item.negation && e["criteria_category"] == item.criteria_category;
            }) 
          break;
        case "M":
          flag = medConditionElementsSelect.findIndex((e) => {
            return e["Eligibility Criteria"] == item.Text && e["negation"] == item.negation && e["criteria_category"] == item.criteria_category;
          }) 
          break;
        case "I":
          flag = interventionElementsSelect.findIndex((e) => {
            return e["Eligibility Criteria"] == item.Text && e["negation"] == item.negation && e["criteria_category"] == item.criteria_category;
          }) 
          break;
        default:
          flag = labTestElementsSelect.findIndex((e) => {
            return e["Eligibility Criteria"] == item.Text && e["negation"] == item.negation && e["criteria_category"] == item.criteria_category;
          }) 
          break;
      }
      return Object.assign(item,{selected:flag!= -1  ? true: false})
    })
    setTableListItems(tableListItemTmp) 
  }, [filteredActivities, filterbyCategories, filterByMin, filterByMax, demographicsElementsSelect,medConditionElementsSelect, interventionElementsSelect, labTestElementsSelect])

  // search bar data
  const minValueLimit = 0
  const maxValueLimit = 100

  // const optionLabelDemographics = originDemographics.map((item, index)=>{    
  //   return item
  // })
  // const optionLabelIntervention = originIntervention.map((item, index)=>{
  //   return item
  // })
  // const optionLabelMedCondition = originMedCondition.map((item, index)=>{
  //   return item
  // })
  // const optionLabelLabTest = originLabTest.map((item, index)=>{
  //   return item
  // })

  const getFrequency = (value) => {
    setMinValue(value[0])
    setMaxValue(value[1])
  }

  // let originLibrary = [...optionLabelDemographics, ...optionLabelIntervention, ...optionLabelMedCondition, ...optionLabelLabTest].filter(
  //   (i) =>
  //       i.Frequency * 100 >= minValueLimit &&
  //       i.Frequency * 100 <= maxValueLimit &&
  //       i.Text !== null
  // )

  const onTextChange = (e) => {
    const val = e.target.value.toLowerCase();
    setResultLoading(true); 
    setSearchedCriteria([]);
    setSearchTxt(val);
    !visibleValue&&setVisibleValue(true)
  }

  const debounce = (func, wait) => {
  let timeout;
  return function(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

  const debouncedFetchData = useCallback(debounce(summaryDefaultList, 500), []);

  useEffect(() => {
    if (searchTxt && searchTxt.length > 1) {
      debouncedFetchData(searchTxt);
    }
  }, [searchTxt, debouncedFetchData]);

  const formatter = (value: number) => {
    return value+'%'
  } 

  const renderNegation = (negation: any) => {
    return (
      <Tooltip title={`${negation?'Negated Entity':''}`} placement="topLeft">
      <span style={  { color: '#ca4a04', display: 'inline-block', padding: '7px',  width: '25px', fontSize: '18px'}}>{negation ? '≠' : ''}</span> 
      </Tooltip>
    )
  }

  const renderItemTitle = (title: string, idx: any) => {
    return (
      <span className="itemTitle">
          {(searchTxt.length < title.length) && compareString(title, title.toLowerCase().split(searchTxt)[0])} 
          <span className={`${
            searchTxt &&
            title.toLowerCase().indexOf(searchTxt.toLowerCase()) > -1
              ? "matched-item"
              : ""
            }`}>
             {compareMiddle(title, searchTxt.length - title.length === 0?title:searchTxt)}
          </span>
          { (searchTxt.length !== 0)&&(searchTxt.length < title.length) && compareMiddle(title, title.toLowerCase().slice((title.toLowerCase().split(searchTxt)[0]+(searchTxt.length - title.length === 0?title:searchTxt)+'').length))}
        </span>
    )
  }

  const renderItem = (title: string, idx: any, Frequency: any, negation: any) => {
    return (
      <>
      {renderNegation(negation)}
      <Tooltip
     title={"Frequency " + Math.round(Frequency * 10000) / 100 + "%"}
     >
      <div
        className="itemLine"
        style={{
          display: 'inline-flex',
          justifyContent: 'space-between',
        }}
      >
        {renderItemTitle(title, idx)}
        <span style={{color:"#CA4A04", marginLeft:"25px"}}>
          Add
        </span>
      </div>
      </Tooltip> 
      </>
    )
  };

  const renderItemClick = (title: string, idx: any, Frequency: any, negation: any) => {
    return (
      <>
      {renderNegation(negation)}
      <Tooltip
     title={"Frequency " + Math.round(Frequency * 10000) / 100 + "%"}
     >
      <div
        className="itemLine"
        style={{
          display: 'inline-flex',
          justifyContent: 'space-between',
        }}
      > 
        {renderItemTitle(title, idx)}
        <span style={{fontWeight:700, marginLeft:"25px"}}>
            <CheckOutlined />
        </span>
      </div>
      </Tooltip>
      </>
    )
  };

  const handleSelectedCriteria = (item, activeType) => {
    switch(item.criteria_category.charAt(0)){
      case "D":
        var index = demographicsElementsSelect.findIndex((domain) => item.Text == domain['Eligibility Criteria'] && item.negation == domain['negation']);
        if(activeType == 1){
          if(index < 0){
            var newItem = {
              ...item,
              "Eligibility Criteria": item.Text,
              "historical_value_free_text": formatHistoryValue(item),
              "user_value_free_text": formatValue(item),
              "historical_timeframe": formatHistoryTime(item),
              "user_timeframe": formatTime(item),
              "Frequency":item.Frequency,
              "Detail":item.details,
              "negation": item.negation,
              "criteria_category":item.criteria_category
            }
            demographicsElementsSelect.push(newItem)
          }
        } else {
          if(index >= 0){
            demographicsElementsSelect.splice(index, 1)
          }
        }
        break;
      case "M":
        var index = medConditionElementsSelect.findIndex((domain) => item.Text == domain['Eligibility Criteria'] && item.negation == domain['negation']);
        if(activeType == 1){
          if(index < 0){
            var newItem = {
              ...item,
              "Eligibility Criteria": item.Text,
              "historical_value_free_text": formatHistoryValue(item),
              "user_value_free_text": formatValue(item),
              "historical_timeframe": formatHistoryTime(item),
              "user_timeframe": formatTime(item),
              "Frequency":item.Frequency,
              "Detail":item.details,
              "negation": item.negation,
              "criteria_category":item.criteria_category
            }
            medConditionElementsSelect.push(newItem)
          }
        } else {
          if(index >= 0){
            medConditionElementsSelect.splice(index, 1)
          }
        }
        break;
      case "I":
        var index = interventionElementsSelect.findIndex((domain) => item.Text == domain['Eligibility Criteria'] && item.negation == domain['negation']);
        if(activeType == 1){
          if(index < 0){
            var newItem = {
              ...item,
              "Eligibility Criteria": item.Text,
              "historical_value_free_text": formatHistoryValue(item),
              "user_value_free_text": formatValue(item),
              "historical_timeframe": formatHistoryTime(item),
              "user_timeframe": formatTime(item),
              "Frequency":item.Frequency,
              "Detail":item.details,
              "negation": item.negation,
              "criteria_category":item.criteria_category
            }
            interventionElementsSelect.push(newItem)
          }
        } else {
          if(index >= 0){
            interventionElementsSelect.splice(index, 1)
          }
        }
        break;
      default:
        var index = labTestElementsSelect.findIndex((domain) => item.Text == domain['Eligibility Criteria'] && item.negation == domain['negation']);
        if(activeType == 1){
          if(index < 0){
            var newItem = {
              ...item,
              "Eligibility Criteria": item.Text,
              "historical_value_free_text": formatHistoryValue(item),
              "user_value_free_text": formatValue(item),
              "historical_timeframe": formatHistoryTime(item),
              "user_timeframe": formatTime(item),
              "Frequency":item.Frequency,
              "Detail":item.details,
              "negation": item.negation,
              "criteria_category":item.criteria_category
            }
            labTestElementsSelect.push(newItem)
          }
        } else {
          if(index >= 0){
            labTestElementsSelect.splice(index, 1)
          }
        }
        break;
    }
  }
  
  // Add button in the list
  const addActivity = (e, record, idx) => { 
    setAddActivityModal(true)
    const tempSelect = {...record, idx: idx}
    const tempModifier = {
      ...initialActivity,
      "Text": record["Text"],
      "negation": record["negation"],
      "criteria_category": record["criteria_category"],
      "Frequency": record["Frequency"]
    }
    setSelectedActivity(tempSelect)
    setModifierActivity(tempSelect)
    setDetailData([
      {
        key: '1',
        name: 'Values',
        history: formatHistoryValue(tempSelect)|| '',
        modifiers: formatValue(tempSelect)==='-'?'':formatValue(tempSelect),
      },
      {
        key: '2',
        name: 'Timeframe',
        history: formatHistoryTime(tempSelect)|| '',
        modifiers: formatTime(tempSelect)==='-'?'':formatTime(tempSelect),
      },
      {
        key: '3',
        name: 'RoA',
        history: tempSelect['historical_roa'] || '-',
        modifiers: tempSelect['user_roa'] || '',
      },
      {
        key: '4',
        name: 'Acuity',
        history:tempSelect['historical_acuity'] || '-',
        modifiers: tempSelect['user_acuity'] || '',
      },
      {
        key: '5',
        name: 'Treatment modifier',
        history: tempSelect['historical_treatment'] || '-',
        modifiers: tempSelect['user_treatment'] || '',
      },
      {
        key: '6',
        name: 'Anatomical site',
        history: tempSelect['historical_anatomical_site'] || '-',
        modifiers: tempSelect['user_anatomical_site'] || '',
      },
    ])
  }

  const handleCancelActivity = () => {
    setAddActivityModal(false)
    setSelectedActivity(initialActivity)
    setModifierActivity(initialActivity);
  } 

  const handleOkActivity = (e, item) => { 
    setAddActivityModal(false);
    setSelectedActivity(initialActivity);
    setModifierActivity(initialActivity);
    const newselectedActivities = [...selectedActivities]
    var newItem = {
      ...item,
      "Eligibility Criteria": item.Text,
      "historical_value_free_text": formatHistoryValue(item),
      "user_value_free_text": formatValue(item),
      "historical_timeframe": formatHistoryTime(item),
      "user_timeframe": formatTime(item),
      "Frequency":item.Frequency,
      "Detail":item.details,
      "negation": item.negation,
      "criteria_category":item.criteria_category
    }

    detailData.forEach(item => {
      if (item.name === "Timeframe") newItem.user_timeframe = item["modifiers"]?.trim()
      if (item.name === "Values") newItem.user_value_free_text = item["modifiers"]?.trim()
      if (item.name === "Acuity") newItem.user_acuity = item["modifiers"]?.trim()
      if (item.name === "RoA") newItem.user_roa = item["modifiers"]?.trim()
      if (item.name === "Treatment modifier") newItem.user_treatment = item["modifiers"]?.trim()
      if (item.name === "Anatomical site") newItem.user_anatomical_site = item["modifiers"]?.trim()
    });


    newselectedActivities.push(newItem)
    setSelectedActivities(newselectedActivities)
    // add or delete criteria
    handleSelectedCriteria(newItem, 1)
    const newPanelData = [...panelActivities]
    newPanelData.push(newItem)
    setPanelActivities(newPanelData)
  }

   // Click X button in the right panel
  const removeActivity = (e, item, index) => {     
    const newPanelData = [...panelActivities]
    newPanelData.splice(index, 1)
    setPanelActivities(newPanelData)

    const newselectedActivities = [...selectedActivities]
    let targetIndex = newselectedActivities.findIndex((e) => {
      return e["Eligibility Criteria"] == item.Text && e["negation"] == item.negation && e["criteria_category"]==item.criteria_category;
    })
    newselectedActivities.splice(targetIndex,1)
    setSelectedActivities(newselectedActivities)
    handleSelectedCriteria(item, 0)

  }

  const columns = [
      {
      title: "Entity",
      dataIndex: "Text",
      key: "Text",
      ellipsis: true, 
      width: 350,
      sorter: (a, b) => (a['Text'] < b['Text'] ? -1 : 1),
      render:  (_, record, index) => {
        return <div style={{width: '100%'}}>
          <Tooltip title={`${record.negation?'Negated Entity':''}`} placement="topLeft">
          <span style={  { color: '#ca4a04', display: 'inline-block', padding: '7px',  height: '14px', marginRight: '10px', width: '25px', fontSize: '18px'}}>{record.negation ? '≠' : ''}</span> 
          </Tooltip>
          <Text
            // ellipsis={true}
            ellipsis={{tooltip: `${record.Text}`} }
            style={{display: 'inline-block', width: "90%",}}
            className="select-text"
            >
              {record.Text}
          </Text>
        </div>
      }
      },
      {
      title: "Category",
      dataIndex: "criteria_category",
      key: "criteria_category",
      width: 300,
      sorter: (a, b) => (a.criteria_category < b.criteria_category ? -1 : 1),
      ellipsis: true,
      render: text => text!== "Lab / Test" ? toSentenceCase(text) : text
      },
      {
      title: "Entity frequency",
      dataIndex: "Frequency",
      key: "Frequency",
      sorter: (a, b) => (a.Frequency < b.Frequency ? -1 : 1),
      ellipsis: true,
      render: (_, item) =>  Math.round(item['Frequency'] * 10000) / 100 + "%"
      
      },
      {
        title: '',
        dataIndex: 'operation',
        key: 'operation',
        render: (_, record, index) => { 
          return selectedActivities.findIndex((e) => {
            return e["Eligibility Criteria"] == record.Text && e["negation"] == record.negation && e["criteria_category"] == record.criteria_category;
          }) !== -1  ? 
          (<div style={{float: 'right', marginRight: 30}}>
            <span style={{paddingRight: '10px', fontSize: '16px'}}> 
            <CheckOutlined />
            </span>
            Added
          </div>) : 
          (<div className="criteria-lib" style={{float: 'right', marginRight: 30}}>
            <Button  onClick={(e) => addActivity(e, record, index)} className="add-button">Add</Button>
          </div>)
      }
    }
  ];

  const onItemClick = ({ key }) => {  
    let item = JSON.parse(key)

    let selectedEle = []
      switch (item.criteria_category.charAt(0)) {
        case "D":
          selectedEle = demographicsElementsSelect
          break;
        case "M":
          selectedEle = medConditionElementsSelect
          break;
        case "I":
          selectedEle = interventionElementsSelect
          break;
        default:
          selectedEle = labTestElementsSelect
          break;
      }
   
    if(selectedEle.findIndex((e) => {
      return e["Eligibility Criteria"] == item.Text && e["negation"] == item.negation && e["criteria_category"] == item.criteria_category;
    }) !== -1) {
      return
      // handleOkActivity(null, item)
    } else {
      setAddActivityModal(true); 
      setVisibleValue(false);
      setSelectedActivity(item) 
      setModifierActivity(item)
      setDetailData([
        {
          key: '1',
          name: 'Values',
          history: formatHistoryValue(item)|| '',
          modifiers: formatValue(item)==='-'?'':formatValue(item),
        },
        {
          key: '2',
          name: 'Timeframe',
          history: formatHistoryTime(item)|| '',
          modifiers: formatTime(item)==='-'?'':formatTime(item),
        },
        {
          key: '3',
          name: 'RoA',
          history: item['historical_roa'] || '-',
          modifiers: item['user_roa'] || '',
        },
        {
          key: '4',
          name: 'Acuity',
          history:item['historical_acuity'] || '-',
          modifiers: item['user_acuity'] || '',
        },
        {
          key: '5',
          name: 'Treatment modifier',
          history: item['historical_treatment'] || '-',
          modifiers: item['user_treatment'] || '',
        },
        {
          key: '6',
          name: 'Anatomical site',
          history: item['historical_anatomical_site'] || '-',
          modifiers: item['user_anatomical_site'] || '',
        },
      ])
      }
  }
 const loadingIndicator = (
    <Space>
      <LoadingOutlined style={{ fontSize: 16, color:'grey' }} spin />
      <span style={{ fontSize: 16, color:'grey' }}>Loading...</span>
    </Space>
  );
  const menu = (
    <Menu onClick={onItemClick}>
      {/* Show Top 10 matched results */}
      {(searchTxt.length !== 0)&&searchedCriteria.length>0 && (<Menu.ItemGroup title="">
        {
          searchedCriteria.slice(0, 10).map((item,idx)=>{
            if([...demographicsElementsSelect, ...interventionElementsSelect, ...medConditionElementsSelect, ...labTestElementsSelect].findIndex((domain) => item.Text == domain['Eligibility Criteria']&& item.negation == domain['negation'] && item.criteria_category == domain['criteria_category'])<0){
              return <Menu.Item key={JSON.stringify(item)}>{renderItem(item.Text, idx, item.Frequency, item.negation)}</Menu.Item>
            } else {
              return <Menu.Item key={JSON.stringify(item)}>{renderItemClick(item.Text,idx, item.Frequency, item.negation)}</Menu.Item>
            }
          })
        }
      </Menu.ItemGroup>)}
      {/* Show blank when not searching */}
      {searchTxt.length === 0 && <div style={{cursor: "none", padding: 20}}></div>}
      {/* Show info when no results */}
      {(searchTxt.length > 1  && isResultLoading) && <div key="no-result" style={{cursor: "none",  padding: 20}}>
        <Spin spinning={isResultLoading} indicator={loadingIndicator}></Spin>
      </div>}
      {(searchTxt.length === 1  ) && <div key="no-result" style={{cursor: "none", padding: 20}}>Please Enter more than 1 character to start searching...</div>}
      {(searchTxt.length > 1 && searchedCriteria.length === 0 && !isResultLoading) && <div key="no-result" style={{cursor: "none", padding: 20}}>There are no {IEType?.slice(0,9)} criteria in the library that match your search.</div>}
    </Menu>
  );

  const onCategorySelect = ({ key }) => {
    let item = JSON.parse(key.slice(1));
    const newData = [...categories]
    let index = newData.findIndex((d) => d == item);
    if(index < 0) {
      newData.push(item)
    } else {
      newData.splice(index, 1)
    }
    setCategories(newData)
  }

  const cancelFilterDisplay = () => {
    setCategories(categoryList)
    setVisibleFilterValue(false) 
    setMinValue(frequencyFilter[0])
    setMaxValue(frequencyFilter[1])
    setFilterByCategories(categoryList)
    setFilterByMin(frequencyFilter[0])
    setFilterByMax(frequencyFilter[1])
  }

  const applyFilters = () => {
    setFilterByCategories(categories)
    setVisibleFilterValue(false) 
    setFilterByMin(minValue)
    setFilterByMax(maxValue)
  }

  const filterMenu=(
    <div className="category-filters">
      <div className="content">
        <span>Set frequency</span>
        <span style={{ float: "right", fontWeight: 'bold' }}>
          {minValue}% - {maxValue}%
        </span>
      </div>
      <Slider
        range={{ draggableTrack: true }}
        value={[minValue, maxValue]}
        tipFormatter={formatter}
        onAfterChange={getFrequency}
        onChange={getFrequency}
        min={1}
      />
        <Menu onClick={onCategorySelect}>
        {categoryList.map((list_item) => (  <Menu.Item  key={"D"+JSON.stringify(list_item)}>  
        <>
        {categories.includes(list_item) ? (
            <span style={{width: '20%',display: 'inline-block',color:"#3193E5", fontWeight:700, marginLeft:"25px"}}>
            <CheckOutlined />
            </span>
        ) : (
          <span style={{width: '20%',display: 'inline-block',color:"#CA4A04", marginLeft:"25px"}}>
          X
        </span>
        )} 
    </>
    {list_item} </Menu.Item>))} 
        </Menu>
        <div>
        <Button className="cancel-filters" onClick={cancelFilterDisplay}>Cancel</Button>
        <Button className="apply-filters" onClick={applyFilters}>Apply</Button>
        </div>
    </div>
  )

  const addActivityToIE = () => {
    panelActivities.forEach(item => {
      handleSelectedCriteria(item, 1)
    });
    
    if(IEType==='Inclusion Criteria') {
      props.updateIEActivities({
        demographicsElements:demographicsElementsSelect ,
        interventionElements: interventionElementsSelect,
        medConditionElements: medConditionElementsSelect,
        labTestElements: labTestElementsSelect,
      })
    } else if(IEType==='Exclusion Criteria') {
      props.updateIEActivities({
        excluDemographicsElements:demographicsElementsSelect ,
        excluMedConditionElements: medConditionElementsSelect,
        excluInterventionElements: interventionElementsSelect,
        excluLabTestElements: labTestElementsSelect,
      })
    }

    localStorage.setItem('whetherSave', 'true')

    props.history.push({
      pathname: '/scenario',
      state: {
        trial_id: trial_id,
        scenarioId: scenarioId, 
        scenarioType: scenarioType,
        similarHistoricalTrials: similarHistoricalTrials,
        whetherUpdate: 'false',
      }  
    }) 
  }

  const navigateBack = () => {
    if(!readOnly){
        addActivityToIE()
        // props.history.push({
        //   pathname: '/scenario',
        //   state: {
        //     trial_id: trial_id,
        //     scenarioId: scenarioId,
        //   }
        // })
    }else{
        props.history.push({
          pathname: '/scenario',
          state: {
            trial_id: trial_id,
            scenarioId: scenarioId,
            scenarioType: scenarioType,
            similarHistoricalTrials: similarHistoricalTrials,
            whetherUpdate: 'false'
          }
        })
    }
  }

  const changePage = (page) => {
    setCurrent(page) 
  };

  const detailColumns =  [{
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 200,
  },
  {
    title: 'History',
    dataIndex: 'history',
    key: 'history',
    width: 320,
  },
  {
    title: 'Modifiers',
    dataIndex: 'modifiers',
    key: 'modifiers',
    width: 320,
    editable: true,
    render: (_, record) => {
      return <Input style={{ width: "300px", fontSize: 14}} value={record['modifiers']}/>
    }
  },]

  const handleSave = (row) => {
    const newData = [...detailData];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    
    setDetailData(newData);
  };

  const newDetailColumns = detailColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });

  const onCopyToMyModifier = () =>{

    setDetailData([
      {
        key: '1',
        name: 'Values',
        history: formatHistoryValue(selectedActivity)|| '',
        modifiers: formatHistoryValue(selectedActivity)|| '',
      },
      {
        key: '2',
        name: 'Timeframe',
        history: formatHistoryTime(selectedActivity)|| '',
        modifiers: formatHistoryTime(selectedActivity)|| '',
      },
      {
        key: '3',
        name: 'RoA',
        history: selectedActivity['historical_roa'] || '-',
        modifiers: selectedActivity['historical_roa'] || '-',
      },
      {
        key: '4',
        name: 'Acuity',
        history:selectedActivity['historical_acuity'] || '-',
        modifiers: selectedActivity['historical_acuity'] || '-',
      },
      {
        key: '5',
        name: 'Treatment modifier',
        history: selectedActivity['historical_treatment'] || '-',
        modifiers: selectedActivity['historical_treatment'] || '-',
      },
      {
        key: '6',
        name: 'Anatomical site',
        history: selectedActivity['historical_anatomical_site'] || '-',
        modifiers: selectedActivity['historical_anatomical_site'] || '-',
      },
    ])

    setModifierActivity(selectedActivity)
  }
    
  return (
    <div className="activity-ie-container">
    <div className="activity-soa-header_layout"> 
      <div onClick={navigateBack} className="back-btn"><span style={{paddingRight: '10px'}}><ArrowLeftOutlined /></span>Back</div>
      <h3>{toSentenceCase(IEType)} 
      {/* ({filteredActivities.length}) */}
      </h3>
      {/* <p className="sub-heading">You can add criteria from the library</p> */}
    </div>

    <div className="activity-soa-body_layout" > 
    <Row>
      <Col span={18} style={{padding: '2% 5% 5% 5%'}}>
        <Row> 
          <Col span={18}>
            <Dropdown
              overlay={menu}
              overlayClassName="searchbox"
              className="search-soa"
              visible={visibleValue} 
              onVisibleChange={(visible: boolean) => {!visibleValue?setVisibleValue(true):setVisibleValue(false)}}
            >
            <Input
                prefix={<SearchOutlined />}
                style={{ width: '100%', height: 37 }}
                allowClear
                onChange={onTextChange}
                onClick={e => e.preventDefault()} 
                placeholder="Search by keyword" />
              </Dropdown>
          </Col>
          <Col span={6}>
          <Dropdown
              overlay={filterMenu} 
              className="search-soa-filters"
              visible={visibleFilterValue} 
              onVisibleChange={(visible: boolean) => {!visibleFilterValue?setVisibleFilterValue(true):setVisibleFilterValue(false)}}
            >
            <p>Category <DownOutlined  style={{paddingLeft: '3px'}}/></p>
            </Dropdown>
          </Col>
        </Row>
        <br />
        <Row>
          <Col span={24}>
          <Table
              className="add-activity-ie-table"
              columns={columns}
              dataSource= {tableListItems}
              rowKey={record => record.Text.toString() + record.negation.toString() + record.criteria_category.toString() + ''}  
              pagination={{
                position: ["bottomRight"],
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${tableListItems.length} items`,
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions:[ "10", "20", "50", "100"],
                onChange: changePage,
                current: current,
                total: tableListItems.length
              }} 
            />
          </Col>
        
        </Row>
      </Col>
      <Col span={6} className="activities-container">
      <div className="side-panel-heading">Selected entities ({panelActivities.length})
      </div>

      <List 
        className="lists-container"
        bordered
        dataSource={panelActivities}
        renderItem={(item, index) => (
          <List.Item>
            <Typography.Text >
            <Tooltip title={`${item.negation?'Negated Entity':''}`} placement="topLeft">
            <span style={  { color: '#ca4a04', display: 'inline-block', padding: '7px', width: '25px', fontSize: '18px'}}>{item.negation ? '≠' : ''}</span> 
            </Tooltip>
              <span className="category">{`${item['Text']}`}</span><span className="sub-category">{`in ${item['criteria_category']}`}</span> </Typography.Text> 
            <span style={{float: 'right'}} onClick={(e) => removeActivity(e, item, index)}>
              <CloseOutlined />
            </span> 
          </List.Item>
        )}
      />
      <div className="soa-actiity-btn-container">
        <Button onClick={addActivityToIE}
                type="primary"
                disabled={readOnly}
                className="add-soa">Add to {IEType==='Inclusion Criteria'? 'inclusion criteria' : 'exclusion criteria'}</Button>
        <br />
      </div>
      </Col>
    </Row>
      
    </div>

<IEDetailsModal 
      handleCancel={handleCancelActivity} 
      visible={addActivityModal} 
      itemRecord={selectedActivity}
      addInsights={false}
      onCopyToMyModifier={onCopyToMyModifier}
      detailData={ detailData} 
      handleOkActivity={handleOkActivity}
      handleSave={handleSave}
      isAddActivity={true}
    />
  </div>    
  )
}

const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  createSoa: (val) => dispatch(createActions.createSoa(val)),
  updateIEActivities: (val) => dispatch(createActions.updateIEActivities(val))
});
const mapStateToProps = (state) => ({
  newTrial: state.trialReducer,
  newIE: state.ieReducer
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddActivityIE));